import $ from '../core/Dom';

export const usingTouch = () => $('html').hasClass('using-touch');
